module.exports = __webpack_public_path__ + "static/media/metropases-secc.8ceba670.svg";